import { memo } from 'react';

import PropTypes from 'prop-types';

import styles from './SectionHeader.module.scss';

const SectionHeader = ({ headings, filters }) => (
  <div className={styles.header}>
    <div className={styles.headings}>{headings}</div>
    <div className={styles.filters}>{filters}</div>
  </div>
);

SectionHeader.propTypes = {
  headings: PropTypes.node,
  filters: PropTypes.node,
};

export default memo(SectionHeader);
